/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListEmployeeWithHourSchedule = {
    type: 'all-of',
    contains: [{
    type: 'ListedEmployee',
}, {
    properties: {
        totalHours: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
    },
}],
};